import type { $Fetch } from "ofetch";

/**
 * Nome do Controller da API
 */
const controller = "/contratado";

/**
 * Classe de gerenciamento de chamadas da API do Contratado
 *
 * @class
 */
export default class ContratadoApi {
    /**
     * Instância da dependência da API (ofetch)
     */
    private api;

    /**
     * Cria uma nova instância da classe ContratadoApi.
     * @constructor
     * @param api - Instância da dependência da API (ofetch).
     */
    constructor(api: $Fetch) {
        this.api = api;
    }

    /**
   * @returns registro do paciente
   */
    lerRegistro(codContratado: number, codOperadora: number) {

        return this.api<ApplicationModule[]>(`${controller}/lerRegistro`, {
            method: "GET",
            params: { codContratado, codOperadora }
        });
    }

    /**
  * @returns registro do paciente
  */
    listarCbo(dataInicio?: string, dataFim?: string, itensperiodo?: boolean) {
        return this.api<ApplicationModule[]>(`${controller}/listar-combo`, {
            method: "GET",
            params: { dataInicio, dataFim, itensperiodo }
        });
    }

    /**
     * @returns registro por Cnpj
     */
    listarPorCnpj(descricao?: string, CNPJ?: string) {
        descricao = descricao ?? "";
        CNPJ = CNPJ ?? "";
        return this.api<ApplicationModule[]>(`${controller}/listarporcnpj`, {
            method: "GET",
            params: { descricao, CNPJ }
        });
    }
}